import SocketConnect from "./socket-connect";
import throttle from "../utils/throttle";
import _ from "lodash";
import { electronLog } from "@laigu/utils/electron";

let myMessages = [];
let colMessages = [];
let myConversation = [];
let colConversation = [];
let visitData = [];
let offlineData = [];
let visitComeOfflineMap = {};
const visitorTime = 4000;
const msgTime = 0;

const getMyMessage = (emitter) => {
  if (myMessages && myMessages.length > 0) {
    emitter.emit("getMyMessage", myMessages);
    myMessages = [];
  }
};

const getColMessage = (emitter) => {
  if (colMessages && colMessages.length > 0) {
    emitter.emit("getColleaguesMessage", colMessages);
    colMessages = [];
  }
};

const getMyConversation = (emitter) => {
  emitter.emit("getMyConversation", myConversation);
  myConversation = [];
};

const getColConversation = (emitter) => {
  emitter.emit("getColConversation", colConversation);
  colConversation = [];
};

const handleVisitorCome = (emitter) => {
  emitter.emit("visitorCome", visitData);
  visitData = [];
};

const handleOffline = (emitter) => {
  emitter.emit("offline", offlineData);
  offlineData = [];
};

function parseVisitOfflineData(data) {
  const visit = [];
  const offline = [];
  Object.values(data).map((msg) => {
    if (msg.action === "visitor_come") {
      visit.push(msg);
    }
    if (msg.action === "offline") {
      offline.push(msg);
    }
  });
  return { visit, offline };
}

const handleSocket = (emitter, url, agentId, entId) => {
  const throttleMyMsg = _.throttle(() => getMyMessage(emitter), 300);
  const throttleColMsg = _.throttle(() => getColMessage(emitter), 600);

  /**
   * visitor_come 与 offline 事件触发频繁，并且状态互斥，这里 visitComeOfflineMap 来保证一个 track_id 对应一个状态
   * 然后定时检查 visitData 与 offlineData 列表， 如果有事件进来就主动触发，清空事件队列
   */
  let flushTimer = null;
  function flushVisitorComeOffline() {
    clearFlushVO();
    flushTimer = setTimeout(() => {
      if (visitData.length || offlineData.length) {
        const { visit, offline } = parseVisitOfflineData(visitComeOfflineMap);
        visitData = visit;
        offlineData = offline;
        handleVisitorCome(emitter);
        handleOffline(emitter);
        visitComeOfflineMap = {};
      }

      flushVisitorComeOffline();
    }, visitorTime);
  }
  function clearFlushVO() {
    clearTimeout(flushTimer);
    flushTimer = null;
  }

  const messageCallback = (message) => {
    // 处理message数据
    const { data } = message;
    const messageData = JSON.parse(data);
    const { action } = messageData;
    // const formattedData = JSON.stringify(messageData, null, 2);
    // console.log("action ===", action, "ws data ===", formattedData);
    // 广播原始 WS 消息供 v2 独立处理（传 JSON 字符串，v2 自行 parse 避免引用共享）
    emitter.emit("ws:raw", data);
    // 添加默认广播事件
    switch (action) {
      case "message":
        // 处理访客消息
        if (messageData && messageData.agent_id === window.parseInt(agentId)) {
          myMessages = [...myMessages, messageData];
          emitter.emit("checkHasConversationData", messageData);
        } else {
          colMessages = [...colMessages, messageData];
          // 对于同事消息也需要检查是否需要补全对话
          emitter.emit("checkHasConversationData", messageData);
        }

        throttleMyMsg();
        throttleColMsg();

        break;
      case "visit_page":
        break;
      case "init_conv":
      case "internal_remind":
        // 后端没有返回is_client_online这个字段 tofix
        messageData.body.is_client_online = true;
        // 如果已经结束了的就不操作
        if (messageData?.body?.ended_on) {
          return;
        }
        // 处理访客对话
        if (
          messageData &&
          messageData.body &&
          messageData.agent_id === agentId &&
          /* 临时，下期后端重做事件, trusted === 2 预托管对话 */ messageData.trusted !==
            2
        ) {
          myConversation = [...myConversation, messageData];
        } else {
          colConversation = [...colConversation, messageData];
        }
        throttle(getMyConversation, null, 0, emitter, 0);
        throttle(getColConversation, null, msgTime, emitter, msgTime);
        // 接受邀请
        emitter.emit("acceptInvite", messageData);
        break;
      case "connect":
        break;
      case "offline":
        electronLog("visitor_offline " + messageData["track_id"]);
        offlineData = [...offlineData, messageData];
        visitComeOfflineMap[messageData["track_id"]] = messageData;
        // throttle(handleOffline, null, visitorTime, emitter, visitorTime);
        break;
      case "agent_redirect":
      case "robot_redirect":
      case "client_redirect":
      case "system_redirect":
      case "timeout_redirect":
      case "bot_redirect_auto":
      case "bot_redirect_manual":
      case "bot_redirect_keyword":
      case "bot_redirect_mpush":
      case "bot_redirect_other":
      case "bot_redirect_force":
      case "bot_redirect_unsolved":
        emitter.emit("redirect", messageData);
        emitter.emit("getStreamEvent", [messageData]);
        break;
      case "end_conv_agent":
      case "end_conv_client":
      case "client_off":
      case "switch_human":
      case "end_conv_timeout":
      case "end_conv_baidu_robot":
        // 访客状态，对话列表
        emitter.emit("endConversation", messageData);
        break;
      case "visitor_come":
        electronLog("visitor_come " + messageData["track_id"]);
        visitData = [...visitData, messageData];
        visitComeOfflineMap[messageData["track_id"]] = messageData;
        // throttle(handleVisitorCome, null, visitorTime, emitter, visitorTime);
        break;
      case "agent_visit_inviting":
        emitter.emit("agentInvite", messageData);
        break;
      case "visit_reject_invite":
        emitter.emit("rejectInvite", messageData);
        break;
      case "client_change_attr":
        // 目前只用于回呼提交电话号码
        emitter.emit("getStreamEvent", [messageData]);
        emitter.emit("agentChangeAttr", messageData);
        break;
      case "client_inputting":
        emitter.emit("clientInput", messageData);
        break;
      case "file_downloaded":
        // 处理访客消息
        emitter.emit("fileDownload", messageData);
        break;
      case "client_tag_create":
        emitter.emit("getStreamEvent", [messageData]);
        break;
      case "client_tag_delete":
        emitter.emit("getStreamEvent", [messageData]);
        break;
      case "client_tag_update":
        emitter.emit("getStreamEvent", [messageData]);
        break;
      case "client_add_tag":
        emitter.emit("clientAddTag", messageData);
        emitter.emit("getStreamEvent", [messageData]);
        break;
      case "client_remove_tag":
        emitter.emit("clientRemoveTag", messageData);
        emitter.emit("getStreamEvent", [messageData]);
        break;
      case "quick_reply_group_create":
        break;
      case "quick_reply_group_delete":
        break;
      case "quick_reply_group_update":
        break;
      case "quick_reply_create":
        break;
      case "quick_reply_update":
        break;
      case "quick_reply_delete":
        break;
      case "quick_replies_refresh":
        break;
      case "agent_update":
        emitter.emit("agentUpdate", messageData);
        break;
      case "agent_delete":
        emitter.emit("agentUpdate", messageData);
        break;
      case "visit_black_del":
      case "visit_black_add":
        emitter.emit("handleVisitBlack", messageData);
        emitter.emit("getStreamEvent", [messageData]);
        break;
      case "visit_black_approve":
      case "visit_black_reject":
        emitter.emit("getStreamEvent", [messageData]);
        break;
      case "agent_kicked":
        emitter.emit("agentKicked", messageData);
        break;
      case "queueing_add":
        emitter.emit("queueAdd", messageData);
        break;
      case "queueing_remove":
        emitter.emit("queueRemove", messageData);
        break;
      case "update_perms":
        break;
      case "update_role":
        break;
      case "intelligent_stats":
        break;
      case "aikongjian_add_reservation":
        break;
      case "kick_self":
        emitter.emit("kickSelf", messageData);
        break;
      case "agent_change_name":
        // emitter.emit('getStreamEvent', [messageData]);
        emitter.emit("agentChangeName", messageData);
        break;
      case "agent_send_sensitive_words":
        emitter.emit("getStreamEvent", [messageData]);
        break;
      case "agent_change_attr":
        // 如果修改了名字
        if (
          messageData.body &&
          messageData.body.attrs &&
          messageData.body.attrs.name
        ) {
          emitter.emit("agentChangeName", messageData);
        }
        // 如果修改了手机号
        if (
          messageData.body &&
          messageData.body.attrs &&
          messageData.body.attrs.tel
        ) {
          emitter.emit("agentChangeTel", messageData);
        }
        emitter.emit("getStreamEvent", [messageData]);
        emitter.emit("agentChangeAttr", messageData);
        break;
      case "client_reply_card":
        if (
          messageData.body &&
          messageData.body.attrs &&
          messageData.body.attrs.name
        ) {
          emitter.emit("agentChangeName", messageData);
        }
        emitter.emit("getStreamEvent", [messageData]);
        emitter.emit("agentChangeAttr", messageData);
        break;
      case "agent_change_custom_field":
      case "agent_send_card":
      case "invite_evaluation":
      case "client_evaluation":
        emitter.emit("getStreamEvent", [messageData]);
        break;
      case "update_product_info":
        emitter.emit("updateProductCard", [messageData]);
        break;
      case "update_conv_tag":
        emitter.emit("getStreamEvent", [messageData]);
        break;
      case "withdraw_msg":
      case "client_withdraw_msg":
        emitter.emit("getStreamEvent", [messageData]);
        emitter.emit("withdrawMsgEvent", [messageData]);
        break;
      case "update_visit_info":
        emitter.emit("updateVisitInfo", messageData);
        break;
      case "update_visitor_invite_status":
        emitter.emit("changeInviteStatus", messageData);
        break;
      case "update_visitor_status":
        emitter.emit("updateVisitorStatus", messageData);
        break;
      case "send_message_fail":
        emitter.emit("getStreamEvent", [messageData]);
        break;
      case "allocate_delayed":
        emitter.emit("getStreamEvent", [messageData]);
        break;
      case "msg_read":
        emitter.emit("msgRead", messageData);
        break;
      case "msg_delivered":
        emitter.emit("msgDelivered", messageData);
        break;
      case "prechat_survey":
        emitter.emit("getStreamEvent", [messageData]);
        break;
      case "update_msg_tag": {
        emitter.emit("update_msg_tag", messageData);
        break;
      }
      case "from_colleague_to_trusteeship": {
        emitter.emit("from_colleague_to_trusteeship", messageData);
        break;
      }
      case "update_conv_flag": {
        emitter.emit("update_conv_flag", messageData);
        break;
      }
      case "bcp_offline":
        emitter.emit("getStreamEvent", [messageData]);
        break;
      case "end_trusteeship":
        emitter.emit("getStreamEvent", [messageData]);
        break;
      case "mbot_interrupt_status_changed":
        emitter.emit("getStreamEvent", [messageData]);
        break;
      case "quick_btn_click":
      case "conv_redirect_summary":
        emitter.emit("getStreamEvent", [messageData]);
        break;
      case "channel_hint":
        emitter.emit("getStreamEvent", [messageData]);
        break;
      case "phone_check":
        emitter.emit("getStreamEvent", [messageData]);
        break;
      case "wechat_copy":
        emitter.emit("getStreamEvent", [messageData]);
        break;
      case "msg_app_open":
        emitter.emit("getStreamEvent", [messageData]);
        break;
      case "GET_NEW_COMMENT":
        emitter.emit("GET_NEW_COMMENT", messageData);
        break;
      default:
    }
  };

  // 环球移民 websocket 降级验证:LIVECHAT-14923
  // const isDowngrade = [433, 67930, 306323].includes(+entId);
  const socketConnectInstance = new SocketConnect({
    socketConfig: { url, isDowngrade: false },
    openCallback: () => {
      emitter.emit("connect");
      flushVisitorComeOffline();
    },
    closeCallback: () => {
      emitter.emit("close");
      clearFlushVO();
    },
    messageCallback: messageCallback,
    reconnectCallback: () => {
      emitter.emit("reconnect");
    },
    socketReconnectMaxCountCallback: () => {
      emitter.emit("socketReconnectMaxCount");
    },
  });
  window._LAIGU_SOCKET_CONNECT_INS_ = socketConnectInstance;

  // 启动 SockJs 连接
  socketConnectInstance.doConnect();

  return socketConnectInstance;
};

export default handleSocket;
